<template>
	<div class="breadcrumb-previous-path d-flex align-items-center">
		<template v-for="(path, index) in paths">
			<router-link
				class="text-black"
				:style="{ fontSize: `${fontSize}px` }"
				:key="`path${index}`"
				:to="`${path.url}`">
				<span>{{ path.title }} </span>
			</router-link>
			<i v-if="!isLastPathIndex(index)" :key="index" class="material-icons breadcrumb-icon" :style="{ fontSize: `${fontSize + 8}px` }">chevron_right</i>
		</template>
	</div>
</template>

<script>
export default {
	props: {
		paths: {
			type: Array,
		},
		fontSize: {
			type: Number,
			default: 16,
		},
	},
	methods: {
		isLastPathIndex(currentIndex) {
			return currentIndex === this.paths.length - 1;
		},
	},
};
</script>

<style>
/* .breadcrumb-previous-path {
	color: #0098DA;
	font-weight: 600;
	font-size: 14px;
	line-height: 21px;
	text-transform: capitalize;
}

.breadcrumb-current-path {
	color: #F9972D;
	font-weight: 700;
	font-size: 14px;
	line-height: 21px;
	text-transform: capitalize;
} */
.text-black {
	color : #656565;
}

.breadcrumb-icon-wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>
